@if (maintenancePageActive === false) {
  @if ((showPrimeModal$ | async) === false) {
    <app-header></app-header>
    <div [@transition]="routeAnimation" [ngClass]="notBodyScroll$(outlet) | async">
      <app-router-outlet #outlet="outlet"></app-router-outlet>
    </div>
    @defer (when ((isMobile$ | async) === false)) {
      @if ((isMobile$ | async) === false) {
        <app-footer></app-footer>
      }
    }
  } @else {
    <app-modal-prime 
      [isMobile]="isMobile$ | async"
      [userInfo]="userInfo$ | async">
    </app-modal-prime>
  }
} @else {
  <app-maintenance-page></app-maintenance-page>
}
